import { resolveTimeout } from "@/lib/timeout/resolve-timeout";
import type { FollowRetryState } from "./follow-retry-state";
import { remainingOutageSeconds } from "./remaining-outage-seconds";

/** A request may not outlive the outage budget it is being retried under. */
export function followRequestTimeoutMs(
  retry: FollowRetryState,
  maxOutageMs: number | null,
  now: number,
): number {
  if (retry.outageStartedAt === null) {
    return resolveTimeout();
  }
  const remainingMs =
    remainingOutageSeconds(retry.outageStartedAt, now, maxOutageMs) * 1_000;
  return Math.max(1, Math.min(resolveTimeout(), remainingMs));
}
